import React from 'react';
import PropTypes from 'prop-types';
import styles from '../hiwTemplate.module.scss';
import SmartImage from '../../smartImage/smartImage';

function HiwStepImage({ onHover, onHoverExit, isCurrent, ...props }) {
  return (
    <li
      className={`${styles.hiwTemplateStepImage} ${
        !isCurrent && styles.hiwTemplateStepImageHidden
      }`}
    >
      <SmartImage
        onMouseEnter={onHover}
        onMouseLeave={onHoverExit}
        aria-current={isCurrent}
        alt={props.alt}
        src={props.src}
        loading="lazy"
        width={props.width}
        height={props.width}
        data-testid={props['data-testid']}
      />
    </li>
  );
}

HiwStepImage.propTypes = {
  onHover: PropTypes.func.isRequired,
  onHoverExit: PropTypes.func.isRequired,
  isCurrent: PropTypes.bool.isRequired,
};

function HiwImages(props) {
  return <ul className={styles.hiwTemplateImages} {...props} />;
}

export { HiwImages, HiwStepImage };
